import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88bd4208"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sf-account-kind-banner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Individual subscription", -1))
const _hoisted_3 = { class: "tw-text-center tw-mt-8" }
const _hoisted_4 = {
  key: 1,
  class: "sf-account-kind-banner"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School subscription", -1))
const _hoisted_6 = { class: "tw-text-center tw-mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountShortDescription = _resolveComponent("AccountShortDescription")!

  return (_ctx.type == 'individual')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createVNode(_component_AccountShortDescription, {
            type: "individual",
            class: "tw-text-mainbg1"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onRegister && _ctx.onRegister(...args))),
              class: "sf-btn-primary tw-mx-2"
            }, " Purchase ")
          ])
        ])
      ]))
    : (_ctx.type == 'school')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createVNode(_component_AccountShortDescription, {
              type: "school",
              class: "tw-text-mainbg1"
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRegister && _ctx.onRegister(...args))),
                class: "sf-btn-primary tw-mx-2"
              }, " Purchase ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}